import {useMemo} from "react";
import {
	useGetVoyageTemplatesSingleVoyageQuery
} from "@containers/singleVoyage/voyageTemplates/queryHooks/useVoyageTemplatesSingleVoyageQuery";

/** Template titles by id, from the account's template list (one cached request for a whole table). */
export function useVoyageTemplateTitlesSingleVoyage(accountId: string | number): Map<number, string> {

	const {data} = useGetVoyageTemplatesSingleVoyageQuery({
		params: {accountId},
	})

	return useMemo(() => {
		return new Map((data ?? []).map((template) => [template.id, template.title]))
	}, [data])
}
